import styled from 'styled-components';

import { theme } from '../../../../styles/styled';
export const FileName = styled.div`
  font-size: 0.9em;
  font-weight: ${theme.constant.pageTitle.fontWeight};
  word-break: break-word;
`;
